export default "__VITE_ASSET__Di9adyPl__"